import Button from "../components/Button";
import ImageWrapper from "../components/ImageWrapper";
import Icon from "../components/Icon";
import about from "../assets/img/implantology1.jpg";
import { motion, AnimatePresence } from "framer-motion";
import testimonial from "../assets/img/testimonial.jpg";
import Marquee from "react-fast-marquee";
import no1 from "../assets/img/no1.png";
import no2 from "../assets/img/no2.png";
import no3 from "../assets/img/no3.png";
import angel from "../assets/img/angel.png";
import ContactForm from "../sections/ContactForm";
import { marqueeData } from "../utils/marquee";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect, useState } from "react";
import "react-before-after-slider-component/dist/build.css";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
    const [isOpen, setIsOpen] = useState(false);
  
    const openModal = (img) => {
        setIsOpen(true);
        setModalData(img)
    }
    const closeModal = () => setIsOpen(false);
  const [modalData, setModalData] = useState(null);

  let mm = gsap.matchMedia();

  useLayoutEffect(() => {
    gsap.from(".hero .gsap_reveal", {
      yPercent: 25,
      opacity: 0,
      duration: 1,
    });

    gsap.from(".gsap_servicecard", {
      yPercent: 25,
      opacity: 0,
      duration: 1,
      stagger: 0.25,
      scrollTrigger: {
        trigger: ".gsap_servicecard",
      },
    });

    mm.add("(min-width: 800px)", () => {
      gsap.from(".about .gsap_reveal", {
        yPercent: 25,
        opacity: 0,
        duration: 1,
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".about .gsap_reveal",
        },
      });
    });

    gsap.from(".testimonials .gsap_reveal", {
      yPercent: 25,
      opacity: 0,
      duration: 1,
      stagger: 0.25,
      scrollTrigger: {
        trigger: ".testimonials .gsap_reveal",
      },
    });

    gsap.from(".gsap_testimonial", {
      xPercent: 25,
      opacity: 0,
      duration: 1,
      stagger: 0.25,
      scrollTrigger: {
        trigger: ".testimonials",
      },
    });

    gsap.from(".benefits .gsap_reveal", {
      yPercent: 25,
      opacity: 0,
      duration: 1,
      stagger: 0.25,
      scrollTrigger: {
        trigger: ".benefits .gsap_reveal",
      },
    });
  }, []);

  return (
    <>
      <div className="hero w-full bg-hero-home-mobile lg:bg-hero-home bg-cover h-screen">
        <div className="gsap_reveal page__width flex flex-col gap-4 items-start h-full justify-center">
          <p className="uppercase text-sm text-brand">
            Дентална клиника "Томов"
          </p>
          <h1 className="font-extrabold text-3xl lg:text-5xl lg:w-1/2 text-white">
            Цялостно решение за здрава и красива усмивка
          </h1>
          <p className="text-white text-lg lg:w-1/2">
            Насладете се на първокласна стоматологична грижа с лично отношение.
            Нашият отдаден екип е тук, за да направи посещението ви удобно и
            ефективно.
          </p>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
            <Button href="/contact">Свържете се с нас</Button>
            <Button href="/about" type="ghost">
              За Нас
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-wrap justify-center gap-4 mt-8 lg:page__width items-center">
        <a
          href="/services/orthodontics"
          className="gsap_servicecard w-2/5 lg:w-1/5 flex flex-col h-64 lg:h-[350px] rounded-lg bg-cover bg-center items-center justify-center text-xl font-bold text-white overflow-hidden"
        >
          <div className="bg-cover text-center text-base lg:text-lg bg-center w-full h-full bg-s2 hover:scale-110 transition-all duration-500 flex flex-col items-center justify-center">
            Ортодонтия
          </div>
        </a>
        <a
          href="/services/implantology"
          className="gsap_servicecard w-2/5 lg:w-1/5 flex flex-col h-64 lg:h-[350px] rounded-lg bg-cover bg-center items-center justify-center text-xl font-bold text-white overflow-hidden"
        >
          <div className="bg-cover text-center text-base lg:text-lg bg-center w-full h-full bg-s1 hover:scale-110 transition-all duration-500 flex flex-col items-center justify-center">
            Имплантология
          </div>
        </a>
        <a
          href="/services/edm"
          className="gsap_servicecard w-2/5 lg:w-1/5 flex flex-col h-64 lg:h-[350px] rounded-lg bg-cover bg-center items-center justify-center text-xl font-bold text-white overflow-hidden"
        >
          <div className="bg-cover text-center text-base lg:text-lg bg-center w-full h-full bg-s3 hover:scale-110 transition-all duration-500 flex flex-col items-center justify-center">
            Естетична Дентална Медицина
          </div>
        </a>
        <a
          href="/services/children"
          className="gsap_servicecard w-2/5 lg:w-1/5 flex flex-col h-64 lg:h-[350px] rounded-lg bg-cover bg-center items-center justify-center text-xl font-bold text-white overflow-hidden"
        >
          <div className="bg-cover text-center text-base lg:text-lg bg-center w-full h-full bg-s4 hover:scale-110 transition-all duration-500 flex flex-col items-center justify-center">
            Детска Ортодонтия
          </div>
        </a>
      </div>
      {/* 
            <div className="page__width flex mt-20 items-center justify-center">
                <ReactBeforeSliderComponent
                    firstImage={FIRST_IMAGE}
                    secondImage={SECOND_IMAGE}
                    className='w-32'
                />
            </div> */}

      <section id="testimonials">
        <div className="my-20 flex flex-col items-center">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-center text-2xl lg:text-3xl font-extrabold text-heading mb-8">
            Ето и какво постигаме с пациентите си:
          </h2>
          <Marquee className="w-full" autoFill>
            {marqueeData[0].map((img) => {
              return (
                <>
                  <ImageWrapper
                    src={img.src}
                    alt={img.alt}
                    className="w-40 h-40 lg:w-64 lg:h-64 mx-3 lg:mx-6 rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                    onClick={() => openModal(img)}
                  />
                </>
              );
            })}
          </Marquee>
          <Marquee className="w-full mt-12" direction="right" autoFill>
            {marqueeData[1].map((img) => {
              return (
                <>
                  <ImageWrapper
                    src={img.src}
                    alt={img.alt}
                    className="w-40 h-40 lg:w-64 lg:h-64 mx-3 lg:mx-6 rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                    onClick={() => openModal(img)}
                  />
                </>
              );
            })}
          </Marquee>
            <AnimatePresence>
              {isOpen && (
                <motion.div
                  className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={closeModal} // Close when clicking outside
                >
                  {/* Modal Content */}
                  <motion.div
                    className="shadow-lg w-[90%] lg:w-1/4 relative"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    onClick={(e) => e.stopPropagation()} // Prevent closing on click inside
                  >
                    {/* Close Button */}
                    <button
                      className="absolute top-4 right-4 text-gray-600 hover:text-black text-2xl"
                      onClick={closeModal}
                    >
                      &times;
                    </button>

                    <ImageWrapper
                      src={modalData.src}
                      alt="Modal Image"
                      className="w-full mx-auto lg:w-full rounded-lg"
                    />
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          {/* ) :  <div className="w-screen h-screen flex items-center justify-center fixed top-0 bottom-0 left-0 right-0 z-[99]">
             <div
              className="w-screen h-screen fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-60"
              onClick={() => setModalData(null)}
            ></div>
            <div className="relative flex flex-col lg:flex-row items-center gap-4 lg:gap-8 w-10/12 lg:w-3/4 bg-white rounded-lg p-8 z-[999]">
              <ImageWrapper
                src={modalData.src}
                alt="Modal Image"
                className="w-full lg:w-2/5 rounded-lg"
              />
              <div className="flex w-full lg:w-3/5 flex-col items-start">
                <a
                  href={modalData.caseHref}
                  className="uppercase text-brand font-bold text-xs lg:text-base underline"
                >
                  {modalData.caseTitle}
                </a>
                <div className="flex flex-col items-start lg:flex-row lg:items-center gap-2">
                  <h3 className="text-xl lg:text-3xl font-bold text-heading">
                    {modalData.title}
                  </h3>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-1 rounded-full py-2 px-4 font-semibold text-xs lg:text-sm uppercase bg-[#EEE] text-[#A0A0A0]">
                      <Icon
                        name="address"
                        className="w-5 h-5 text-[#A0A0A0]"
                      />
                      {modalData.city}
                    </div>
                    <div className="flex items-center gap-1 rounded-full py-2 px-4 font-semibold text-xs lg:text-sm uppercase bg-[#EEE] text-[#A0A0A0]">
                      <Icon name="user" className="w-5 h-5 text-[#A0A0A0]" />
                      {modalData.age}год.
                    </div>
                  </div>
                   <div className='flex items-center gap-1 rounded-full py-2 px-4 font-semibold text-sm uppercase bg-[#ECF6FD] text-brand'>
                                      <Icon name="user" className="w-5 h-5 text-brand" />
                                      {modalData.age}год.
                                  </div> 
                </div>
                <p className="text-base lg:text-lg text-body my-4">
                  {modalData.description}
                </p>
                 <div className="w-full flex items-center flex-row ">
                                  <ImageWrapper
                                      src={modalData.testimonialImage}
                                      alt="Testimonial pfp"
                                      className="w-24 h-24 rounded-full shrink-0"
                                  />
                                  <div className="rounded-xl w-full lg:w-3/5 flex flex-col gap-2 justify-center items-start pl-20 pr-8 -ml-16 -z-10 bg-[#FAFAFA] border border-[#F1F1F1] py-8">
                                      <div className='flex items-center gap-1 lg:gap-2'>
                                          <Icon name="star" className="w-4 h-4" />
                                          <Icon name="star" className="w-4 h-4" />
                                          <Icon name="star" className="w-4 h-4" />
                                          <Icon name="star" className="w-4 h-4" />
                                          <Icon name="star" className="w-4 h-4" />
                                      </div>
                                      <p className="text-sm lg:text-base text-body">
                                          “{modalData.testimonialComment}”
                                      </p>
                                      <p className='uppercase text-xs lg:text-sm text-heading'>~ {modalData.testimonialName}</p>
                                  </div>
                              </div> 
              </div>
              <button
                className="lg:absolute top-4 right-4 flex items-center justify-center rounded-full border-2 font-bold border-brand text-brand bg-none px-4 py-2 hover:text-white hover:bg-brand transition-all duration-200"
                onClick={() => setModalData(null)}
              >
                Затвори
              </button>
            </div>
          </div>
          null} */}
        </div>
      </section>
      <div className="about relative page__width my-40 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <Icon
          name="tooth"
          className="-z-50 absolute rotate-[38deg] right-0 top-0 w-16 h-16"
        />
        <div className="gsap_reveal w-full lg:w-1/2">
          <ImageWrapper src={about} className="w-full rounded-lg" />
        </div>
        <div className="gsap_reveal w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            15+ години сертифицирана дентална практика
          </h2>
          <p className="text-base text-body font-normal">
            С над 15-годишен опит TomovDental е изградила репутация на отличен
            специалист. Нашият екип е в крак с най-новите дентални технологии и
            техники, за да гарантираме, че получавате възможно най-доброто
            лечение.
          </p>

          <div className="flex gap-4 items-center">
            <div className="p-4 bg-white shadow-icon rounded-md flex items-center justify-center">
              <Icon name="achievement" className="w-7 h-7 text-brand" />
            </div>
            <h3 className="text-2xl font-bold text-heading">
              Персонализирани планове за вашата усмивка
            </h3>
          </div>
          <div className="flex flex-col mb-2">
            <p className="text-base text-body font-normal">
              Всеки пациент получава индивидуален план за лечение, съобразен с
              неговите специфични нужди.
            </p>
          </div>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width relative flex flex-col items-center justify-center my-40">
        <Icon
          name="tooth"
          className="-z-50 absolute -rotate-[19deg] left-0 top-0 w-16 h-16"
        />
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-center text-2xl lg:text-3xl font-extrabold text-heading mb-8">
          Защо да изберете дентална клиника Томов?
        </h2>
        <div className="benefits mt-12 flex flex-col lg:flex-row items-start text-center justify-between gap-16 lg:gap-8">
          <div className="gsap_reveal flex flex-col w-full items-center gap-2">
            <Icon
              name="hygiene"
              className="w-16 h-16 shadow-icon rounded-xl p-4 text-brand"
            />
            <h3 className="text-heading font-extrabold text-xl lg:text-2xl">
              Хигиена
            </h3>
            <p>
              Ние гарантираме най-високи стандарти за стерилизация и качество,
              осигурявайки безопасно и ефективно лечение.
            </p>
          </div>
          <div className="gsap_reveal flex flex-col w-full items-center gap-2">
            <Icon
              name="equipment"
              className="w-16 h-16 shadow-icon rounded-xl p-4 text-brand"
            />
            <h3 className="text-heading font-extrabold text-xl lg:text-2xl">
              Оборудване
            </h3>
            <p>
              С най-новите технологии в стоматологията гарантираме най-добри
              резултати за вашето дентално здраве.
            </p>
          </div>
          <div className="gsap_reveal flex flex-col w-full items-center gap-2">
            <Icon
              name="pricetag"
              className="w-16 h-16 shadow-icon rounded-xl p-4 text-brand"
            />
            <h3 className="text-heading font-extrabold text-xl lg:text-2xl">
              Достъпни цени
            </h3>
            <p>
              Предлагаме високо качество на достъпни цени и гъвкави финансови
              планове, защото всеки заслужава отлична дентална грижа.
            </p>
          </div>
        </div>
      </div>

      <div className="testimonials page__width mt-20 justify-between flex flex-col lg:flex-row items-center gap-8">
        <div className="gsap_reveal w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-start text-2xl lg:text-3xl font-extrabold text-heading">
            Какво казват пациентите ни за нас:
          </h2>
          <p className="text-base text-body font-normal">
            Над 5000 пациенти из цяла България се довериха на нас и на нашата
            експертиза. Ето какво споделиха те за нас:
          </p>
          <Button type="cta-border" href="/contact">
            Бъди следващият!
          </Button>
        </div>
        <div className="w-full lg:w-1/2 flex flex-col lg:flex-row items-end gap-4">
          <div className="w-full lg:w-1/2 lg:h-80 rounded-xl flex items-center px-8 py-12 shadow-testimonial">
            <div className="flex flex-col items-center text-center gap-2">
              <Icon name="quotes" className="w-8 h-8 text-brand" />
              <p className="text-base text-body font-normal">
                "Преобразих усмивката си, без дори да се забелязва, че нося
                шини. Невероятно, удобно, и практично. Благодаря, Томов!"
              </p>
              <h3 className="text-2xl font-bold text-heading">
                Камен Стефанов
              </h3>
            </div>
          </div>
          <div className="w-full lg:w-1/2 lg:h-80 rounded-xl flex items-center px-8 py-12 shadow-testimonial">
            <div className="flex flex-col items-center text-center gap-2">
              <Icon name="quotes" className="w-8 h-8 text-brand" />
              <p className="text-base text-body font-normal">
                "Лечението ми мина успешно и безболезнено. Много съм доволен,
                изключително коректен и сплотен екип. Препоръчвам на всеки"
              </p>
              <h3 className="text-2xl font-bold text-heading">Асен Ненчев</h3>
            </div>
          </div>
          {/* <div className="gsap_testimonial w-full lg:w-4/5 rounded-xl flex items-center px-8 py-12 shadow-testimonial">
                        <div className="flex flex-col items-start w-4/5 gap-2">
                            <Icon
                                name="quotes"
                                className="w-8 h-8 text-brand"
                            />
                            <p className="text-base text-body font-normal w-5/6">
                                "Преобразих усмивката си, без дори да се забелязва, че нося шини. Невероятно и ефектино! Благодаря Томов!"
                            </p>
                            <h3 className="text-2xl font-bold text-heading">
                                Камен Василев
                            </h3>
                        </div>
                        <ImageWrapper
                            src={testimonial}
                            alt="testimonial"
                            className="w-1/3 rounded-full"
                        />
                    </div> */}
        </div>
      </div>
      {/* <div className="w-full flex items-center">
                <Button
                    type="cta-border"
                    className="mx-auto"
                    href="#">
                    Виж всички резултати
                </Button>
            </div> */}

      <div className="page__width flex flex-col mt-8 items-center gap-12">
        <div className="flex mb-8 mt-16 flex-col items-center">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-center lg:text-start text-2xl lg:text-3xl font-extrabold text-heading">
            Не пренебрегвайте здравето си!
          </h2>
        </div>
        <div className="flex items-center gap-2 justify-center">
          <div className="relative flex flex-col w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-[#FF4F61]">
            <ImageWrapper
              src={no1}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Живял съм толкова години без брекети, нямам нужда от тях на този
            етап от живота си.
          </div>
          <div className="bg-white w-12 h-12 rounded-full absolute z-50"></div>
          <div className="relative flex w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-brand">
            <ImageWrapper
              src={angel}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Ще се погрижа за усмивката си, независимо от възрастта.
          </div>
        </div>
        <div className="flex items-center gap-2 justify-center">
          <div className="relative flex flex-col w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-[#FF4F61]">
            <ImageWrapper
              src={no2}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Детето ми нищо не го боли, няма причина да ходи на преглед.
          </div>
          <div className="bg-white w-12 h-12 rounded-full absolute z-50"></div>
          <div className="relative flex w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-brand">
            <ImageWrapper
              src={angel}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Щастливи сме, че детето ни расте без кариеси.
          </div>
        </div>
        <div className="flex items-center gap-2 justify-center">
          <div className="relative flex flex-col w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-[#FF4F61]">
            <ImageWrapper
              src={no3}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Няма смисъл да се лекуват млечните зъби, така и така ще се сменят
          </div>
          <div className="bg-white w-12 h-12 rounded-full absolute z-50"></div>
          <div className="relative flex w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-brand">
            <ImageWrapper
              src={angel}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Здравето на млечните зъби е същото толкова важно, колкото и на
            постоянните
          </div>
        </div>
        <div className="flex items-center gap-2 justify-center">
          <div className="relative flex flex-col w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-[#FF4F61]">
            <ImageWrapper
              src={no1}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Зъбите ми били криви. Аз пък си ги харесвам напълно
          </div>
          <div className="bg-white w-12 h-12 rounded-full absolute z-50"></div>
          <div className="relative flex w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-brand">
            <ImageWrapper
              src={angel}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Искам най-доброто за своята усмивка!
          </div>
        </div>
        <div className="flex items-center gap-2 justify-center">
          <div className="relative flex flex-col w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-[#FF4F61]">
            <ImageWrapper
              src={no2}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Детето ми е едва на 4г. и може само да си мие зъбите
          </div>
          <div className="bg-white w-12 h-12 rounded-full absolute z-50"></div>
          <div className="relative flex w-1/2 lg:w-[400px] lg:max-w-[400px] items-center justify-center text-center text-sm lg:text-base text-white h-40 py-0 lg:py-4 px-6 lg:px-12 rounded-lg bg-brand">
            <ImageWrapper
              src={angel}
              className="absolute -top-6 lg:-top-8 w-12 lg:w-16"
            />
            Всеки ден помагам на детето си с правилното миене на зъби.
          </div>
        </div>
      </div>

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="/contact">Свържи се с нас</Button>
      </div>
    </>
  );
}
